// React
import { createContext } from 'react';

// Listing Context
export const DetailContext = createContext({});
